import { FC, useMemo } from 'react'
import { ImageTransformer } from 'src/relay/Transformers/ImageTransformer'
import VideoPush, { VideoPushProps } from 'src/components/VideoPush'
import { getThemeColor } from 'src/relay/Transformers/ThemeTransformer'
import { YOUTUBE_OPTIONS } from 'src/constant'
import { useTranslation } from 'react-i18next'
import { RichTextTransformer } from 'src/relay/Transformers/RichTextTransformer'

import { BlockProps } from '../props'

import { VideoSliderBlockProps } from './props'

const VideoSliderBlock: FC<BlockProps<VideoSliderBlockProps>> = ({
  data,
  configuration,
  locale,
}) => {
  const { t } = useTranslation()
  const props: VideoPushProps = useMemo(() => {
    return {
      color: getThemeColor(data.theme?.data),
      ...(data.title && {
        thumbnails: {
          title: data.title || '',
        },
      }),
      ...(data.title && {
        blockTitleProps: {
          title: data.title,
          ...(data.sectionTitle && {
            tag: data.sectionTitle,
          }),
        },
      }),
      // v4: `videos.data[].attributes`; v5: flat array.
      videos: ((data.videos as any)?.data ?? data.videos ?? []).map(
        (videoRaw: any) => {
          const attrs: any = videoRaw?.attributes ?? videoRaw
          const coverDesktop =
            attrs?.coverImageDesktop?.data ?? attrs?.coverImageDesktop
          return {
            options: { ...YOUTUBE_OPTIONS, videoId: attrs?.videoId },
            title: attrs?.title || '',
            cover: {
              imageProps: ImageTransformer(coverDesktop),
            },
            texts: {
              play: t('video.play'),
              playVideo: t('video.playVideo'),
              pause: t('video.pause'),
              skip: t('video.skip'),
              mute: t('video.mute'),
              unmute: t('video.unmute'),
              transcript: t('video.transcript'),
              fullscreen: t('video.fullscreen'),
              exitFullscreen: t('video.exitFullscreen'),
            },
            ...(attrs?.transcript && {
              transcriptProps: {
                richTextProps: RichTextTransformer(
                  attrs.transcript,
                  configuration,
                  locale
                ),
                texts: {
                  open: t('transcription.open'),
                  close: t('transcription.close'),
                },
                open: false,
              },
            }),
          }
        }
      ),
      texts: {
        dot: t('slider.dot'),
        previous: t('slider.previous'),
        next: t('slider.next'),
      },
    }
  }, [configuration, data, locale, t])

  return <VideoPush {...props} />
}

export default VideoSliderBlock
